import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import Helmet from 'react-helmet';
import { EmptyState, PageHeader } from 'components';
import { LeftNavLayout, ComposeScreen } from 'containers';
import { connect } from 'react-redux';
import { getSocialAccounts } from 'redux/modules/organization';
import { getReports } from 'redux/modules/reporting';
import { ReportsDashboard, RecentFBPosts, SummaryReport } from 'containers';
import ReportingCharts from './ReportingCharts';
var Reports = (_dec = connect(function (state, props) {
  var orgId = props.params.organizationId;
  return {
    organization: state.organization.current,
    reports: state.reporting.reports && state.reporting.reports[orgId] ? state.reporting.reports[orgId] : []
  };
}, {
  getReports: getReports,
  getSocialAccounts: getSocialAccounts
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Reports, _Component);

  var _super = _createSuper(Reports);

  function Reports() {
    _classCallCheck(this, Reports);

    return _super.apply(this, arguments);
  }

  _createClass(Reports, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getSocialAccounts(this.props.organization.id);
      this.props.getReports(this.props.organization.id);
    }
  }, {
    key: "render",
    value: function render() {
      var reports = this.props.reports;
      var summaryReports = reports && !!reports.length ? reports.filter(function (r) {
        return r.reportType === 'monthly' && !r.isArchived;
      }) : [];
      var checklistReports = reports && !!reports.length ? reports.filter(function (r) {
        return r.reportType === 'facebookChecklist' && !r.isArchived;
      }) : [];
      var upcomingContentReports = reports && !!reports.length ? reports.filter(function (r) {
        return r.reportType === 'upcomingContent' && !r.isArchived;
      }) : [];
      var sidebarItems = [{
        link: "/org/".concat(this.props.organization.id, "/reports/dashboard"),
        linkText: 'Dashboard'
      }, {
        link: "/org/".concat(this.props.organization.id, "/reports/recent-posts"),
        linkText: 'Recent Posts'
      }];

      if (summaryReports.length) {
        sidebarItems.push({
          link: "/org/".concat(this.props.organization.id, "/reports/summary"),
          linkText: 'Monthly Reports'
        });
      }

      if (checklistReports.length) {
        sidebarItems.push({
          link: "/org/".concat(this.props.organization.id, "/reports/facebook-facelift/").concat(checklistReports[0].id),
          linkText: 'Facebook Facelift Report'
        });
      }

      if (upcomingContentReports.length) {
        sidebarItems.push({
          link: "/org/".concat(this.props.organization.id, "/reports/upcoming-content/").concat(upcomingContentReports[0].id),
          linkText: 'Upcoming Content Reports'
        });
      }

      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflow: 'auto',
        height: '100%'
      };
      var wrapStyle = {
        flex: '1 1 auto',
        padding: 0
      };
      var hasFBPage = this.props.organization.SocialAccounts.filter(function (acct) {
        return acct.platform === 'Facebook page';
      })[0]; // don't show the sidebar on the dashboard

      return this.props.location.pathname.includes('dashboard') ? /*#__PURE__*/React.createElement(LeftNavLayout, {
        params: _objectSpread({}, this.props.params),
        wrapStyle: wrapStyle,
        appLayoutInnerStyle: appLayoutInnerStyle
      }, this.props.children) : /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: true,
        sidebarItems: sidebarItems,
        params: _objectSpread({}, this.props.params),
        wrapStyle: wrapStyle,
        appLayoutInnerStyle: appLayoutInnerStyle
      }, this.props.children);
    }
  }]);

  return Reports;
}(Component), _defineProperty(_class2, "propTypes", {
  params: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired
}), _temp)) || _class);
export default Reports;